import moment from "moment/moment";
import InputDatePicker from "../InputDatePicker";
import InputPlaces from "../InputPlaces";

function LocationDateSection({ type, formik, datePickup, dateDropOff, onDatePickupChange, onDateDropOffChange, t }) {
  const minDatePickup = moment()
    .add(type === "tour" ? 12 : 24, "hours")
    .toDate();

  const minTimePickup =
    datePickup && moment(datePickup).isSame(minDatePickup, "day")
      ? moment()
          .add(type === "tour" ? 12 : 24, "hour")
          .toDate()
      : moment().startOf("day").toDate();

  const minDateDropOff = minDatePickup;

  const minTimeDropOff =
    dateDropOff && moment(dateDropOff).isSame(minDateDropOff, "day")
      ? moment(minTimePickup).add(1, "hour").toDate()
      : moment().startOf("day").toDate();

  const handlePlaceChange = (field, jsonField) => (v, i) => {
    formik.setFieldValue(field, i);
    formik.setFieldValue(jsonField, JSON.stringify(v));
  };

  return (
    <>
      <div className="grid grid-cols-1 gap-5 md:grid-cols-2">
        <div className="relative">
          <label className="block mb-2 text-sm font-medium text-slate-400">
            {t("pickup_location") || "Pickup Location"}
          </label>
          <div className="bg-white">
            <InputPlaces
              placeholder="Wirasana Rent A Car"
              onPlaceChanged={handlePlaceChange("pickup_location", "pickup_location_json")}
              {...formik.getFieldProps("pickup_location")}
              className="w-full bg-white text-slate-700 text-base md:text-lg rounded-sm px-5 py-4 focus:outline-none focus:ring-2 focus:ring-[#f5272b] transition-all"
            />
          </div>
          {formik.touched.pickup_location && formik.errors.pickup_location ? (
            <p className="mt-1 text-sm text-red-400 error-modal">{formik.errors.pickup_location}</p>
          ) : null}
        </div>

        <div>
          <label className="block mb-2 text-sm font-medium text-slate-400">{t("pickup_date") || "Pickup Date"}</label>
          <InputDatePicker
            date={datePickup}
            onChange={onDatePickupChange}
            minDate={minDatePickup}
            minTime={minTimePickup}
            error={formik.errors.pickup_date}
            touched={formik.touched.pickup_date}
          />
        </div>
      </div>

      {type !== "transfer_service" && type !== "tour" && (
        <div className="grid grid-cols-1 gap-5 md:grid-cols-2">
          <div className="relative">
            <label className="block mb-2 text-sm font-medium text-slate-400">
              {t("dropoff_location") || "Drop-off Location"}
            </label>
            <div className="bg-white">
              <InputPlaces
                placeholder="Wirasana Rent A Car"
                onPlaceChanged={handlePlaceChange("dropoff_location", "dropoff_location_json")}
                {...formik.getFieldProps("dropoff_location")}
                className="w-full bg-white text-slate-700 text-base md:text-lg rounded-sm px-5 py-4 focus:outline-none focus:ring-2 focus:ring-[#f5272b] transition-all"
              />
            </div>
            {formik.touched.dropoff_location && formik.errors.dropoff_location ? (
              <p className="mt-1 text-sm text-red-400 error-modal">{formik.errors.dropoff_location}</p>
            ) : null}
          </div>

          <div>
            <label className="block mb-2 text-sm font-medium text-slate-400">
              {t("dropoff_date") || "Dropoff Date"}
            </label>
            <InputDatePicker
              date={dateDropOff}
              onChange={onDateDropOffChange}
              minDate={minDateDropOff}
              minTime={minTimeDropOff}
              error={formik.errors.dropoff_date}
              touched={formik.touched.dropoff_date}
              label={t("dropoff_date") || "Drop-off Date"}
            />
          </div>
        </div>
      )}

      {type === "transfer_service" && (
        <div className="relative">
          <label className="block mb-2 text-sm font-medium text-slate-400">
            {t("destination_location") || "Destination Location"}
          </label>
          <div className="bg-white">
            <InputPlaces
              placeholder="Wirasana Rent A Car"
              restrictedByAreaLevel={true}
              onPlaceChanged={handlePlaceChange("dropoff_location", "dropoff_location_json")}
              {...formik.getFieldProps("dropoff_location")}
              className="w-full bg-white text-slate-700 text-base md:text-lg rounded-sm px-5 py-4 focus:outline-none focus:ring-2 focus:ring-[#f5272b] transition-all"
            />
          </div>
          {formik.touched.dropoff_location && formik.errors.dropoff_location ? (
            <p className="mt-1 text-sm text-red-400 error-modal">{formik.errors.dropoff_location}</p>
          ) : null}
        </div>
      )}
    </>
  );
}

export default LocationDateSection;
